<template>
    <div>
      <Pos_inventory_add/>
    </div>
  </template>
  
  <script>
  import Pos_inventory_add from "@/components/adminArin/pos_system/warehouse/inventory/Pos_inventory_add";
  export default {
    name: "PosInventoryAdd",
    components: {
      Pos_inventory_add
    }
  }
  </script>
  
  <style scoped>
  
  </style>
  